import React, { useState } from "react";
import { Card } from "@mui/material";
import NavigationMenu from "../NavigationMenu";
import EficsHeader from "../EficsHeader";

const PageLayout = ({
    title,
    tabs,
    buttons,
    children,
    cardClassName = "ListCard",
    cardStyle,
    showMenuButton = true,
    showNavigationMenu = true
}) => {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <div>
            {showNavigationMenu && (
                <NavigationMenu open={menuOpen} onClose={() => setMenuOpen(false)} />
            )}
            <Card className={cardClassName} style={cardStyle}>
                <EficsHeader
                    onMenuClick={() => setMenuOpen(true)}
                    showMenuButton={showMenuButton}
                    tabs={tabs}
                    buttons={buttons}
                >
                    {title}
                </EficsHeader>
                {children}
            </Card>
        </div>
    );
};

export default PageLayout;
